/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Embed_Captions_AriaInputs */

const en_file_export_embed_captions_aria = /** @type {(inputs: File_Export_Embed_Captions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed closed caption track into video`)
};

const fr_file_export_embed_captions_aria = /** @type {(inputs: File_Export_Embed_Captions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incruster une piste de sous-titres dans la video`)
};

const de_file_export_embed_captions_aria = /** @type {(inputs: File_Export_Embed_Captions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel in das Video einbetten`)
};

const it_file_export_embed_captions_aria = /** @type {(inputs: File_Export_Embed_Captions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora la traccia dei sottotitoli nel video`)
};

const ru_file_export_embed_captions_aria = /** @type {(inputs: File_Export_Embed_Captions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроить субтитры в видео.`)
};

const es_file_export_embed_captions_aria = /** @type {(inputs: File_Export_Embed_Captions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrustar pista de subtítulos en el vídeo`)
};

const zh_cn2_file_export_embed_captions_aria = /** @type {(inputs: File_Export_Embed_Captions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将字幕轨道嵌入视频`)
};

const ja_file_export_embed_captions_aria = /** @type {(inputs: File_Export_Embed_Captions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画に字幕トラックを埋め込む`)
};

const hi_file_export_embed_captions_aria = /** @type {(inputs: File_Export_Embed_Captions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो में क्लोज्ड कैप्शन ट्रैक एम्बेड करें`)
};

const pt_pt2_file_export_embed_captions_aria = /** @type {(inputs: File_Export_Embed_Captions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar legendas ocultas no vídeo`)
};

/**
* | output |
* | --- |
* | "Embed closed caption track into video" |
*
* @param {File_Export_Embed_Captions_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_embed_captions_aria = /** @type {((inputs?: File_Export_Embed_Captions_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Embed_Captions_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_embed_captions_aria(inputs)
	if (locale === "de") return de_file_export_embed_captions_aria(inputs)
	if (locale === "it") return it_file_export_embed_captions_aria(inputs)
	if (locale === "ru") return ru_file_export_embed_captions_aria(inputs)
	if (locale === "es") return es_file_export_embed_captions_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_embed_captions_aria(inputs)
	if (locale === "ja") return ja_file_export_embed_captions_aria(inputs)
	if (locale === "hi") return hi_file_export_embed_captions_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_embed_captions_aria(inputs)
	return en_file_export_embed_captions_aria(inputs)
});